import { FullFormAction } from "../../../../Engine/Core/Store/FullFormAction";

import { TabInfosState } from "./TabInfosState";
import { TabInfosActionTypes } from "./TabInfosActions";

export const tabInfosReducer = (state: TabInfosState, action: FullFormAction): TabInfosState => {
    switch (action.type) {
        case TabInfosActionTypes.ChangeTab: {
            return {
                ...state,
                currentInstance: {
                    ...state.currentInstance,
                    [action.payload.bindingPath]: action.payload.instance,
                },
            };
        }
        case TabInfosActionTypes.SetCurrentTab: {
            return {
                ...state,
                currentTabInstanceIndex: {
                    ...state.currentInstance,
                    [action.payload.bindingPath]: action.payload.instance,
                },
            };
        }
        default:
            return state;
    }
};
